import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=7262b752&scoped=true&"
import script from "./page-footer.vue?vue&type=script&lang=js&"
export * from "./page-footer.vue?vue&type=script&lang=js&"
import style0 from "./page-footer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./page-footer.vue?vue&type=style&index=1&id=7262b752&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7262b752",
  null
  
)

export default component.exports